import type { AfterViewInit, OnInit } from '@angular/core';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-enter-balances-recombinations-table',
  templateUrl: './recombinations-table.component.html',
  styleUrls: ['./recombinations-table.component.scss'],
})
export class EnterBalancesRecombinationsTableComponent implements OnInit, AfterViewInit {
  @Input() recombinationExchange: any;
  @Input() isSmbsFlow: boolean;
  @Input() isSmbsClearBtnClick: boolean;
  @Input() public recombinationTableExchangeType: string;
  @Input() isExternalUser: boolean;
  @Input() isFromTakedownPage: boolean;
  @Output() startedEditing = new EventEmitter<void>();

  public recombinationTableExchangeTypeFinal: string;

  protected recombinationGroups: any[];

  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {
    this.recombinationGroups = this.recombinationExchange.recombinations.recombinations;
    this.recombinationTableExchangeTypeFinal = this.recombinationTableExchangeType;
    // Force change detection after data is assigned
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    // Trigger change detection after all child views are rendered
    this.cdr.detectChanges();
  }

  protected onRowStartedEditing(): void {
    this.startedEditing.emit();
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
